module.exports = __webpack_public_path__ + "static/media/dwellPass-logo-beta-white-emblem-400w.4a3ca621.png";